"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _possibleConstructorReturn;

var _typeof2 = _interopRequireDefault(require("../../helpers/esm/typeof"));

var _assertThisInitialized = _interopRequireDefault(require("./assertThisInitialized"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _possibleConstructorReturn(self, call) {
  if (call && ((0, _typeof2["default"])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return (0, _assertThisInitialized["default"])(self);
}